/* bd-v157 (2026-09-08): toegangshulp op /pages/online-access.
   Uit de conversie-audit, rijen [45] en [47]: de pagina opent met marketing
   en een inlogknop, maar nergens staat wat je doet als je wel betaald hebt
   en je tools toch niet ziet. Gemeten op de live pagina: nul treffers op
   "cannot see", "support", "order number" en "activate".
   Dat is de duurste soort supportvraag: iemand heeft al betaald.

   Alle stappen komen uit bestaande, gepubliceerde bronnen:
     inloggen : FAQ, "Sign in with the email you used to order."
     activatie: verzendbeleid, "Eligible access is activated after full
                payment and account activation."
     support  : support@bizdeckspro.com (contact- en beleidspagina's)
   Er wordt geen enkele nieuwe belofte gedaan. */
(function () {
  'use strict';

  if (!/\/pages\/online-access/i.test(location.pathname)) return;

  // Instellingen uit de theme-editor; zonder instellingen dezelfde teksten.
  var CFG = (window.BD_V149 && window.BD_V149.help) || {};
  function woord(v, terugval) {
    return (typeof v === 'string' && v.length) ? v : terugval;
  }
  function veilig(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  var KOP = woord(CFG.title, 'Purchased but you cannot see your tools?');
  var TOON = woord(CFG.show, 'Show steps');
  var VERBERG = woord(CFG.hide, 'Hide steps');
  var STAPPEN = woord(CFG.steps,
    '<ol>' +
      '<li>Log in with the email address you used to place the order. ' +
        'A second account with a different address will not see the purchase. ' +
        '<a href="/customer_authentication/login?return_to=%2Fpages%2Fonline-access">Log in</a></li>' +
      '<li>Digital access is activated after full payment and account activation. ' +
        'If you have just ordered, complete the account activation email first.</li>' +
      '<li>Open <a href="/pages/my-tools">My Tools</a> again after logging in.</li>' +
      '<li>Still nothing? Email <a href="mailto:support@bizdeckspro.com">support@bizdeckspro.com</a> ' +
        'with your order number and we will sort it out. ' +
        '<a href="/pages/contact">Contact page</a></li>' +
    '</ol>');

  // OA-01 (7 okt 2026): tweede regel met de stappen om seats toe te wijzen. Zelfde feiten als de
  // e-mail "Your BizDecks seat assignment was received": uitnodiging per e-mail, 7 dagen geldig,
  // een seat voor jezelf is meteen actief.
  var SEAT_KOP = woord(CFG.seatsTitle, 'Bought seats for your team?');
  var SEAT_STAPPEN = woord(CFG.seatsSteps,
    '<ol>' +
      '<li>Open the <a href="/pages/seat-dashboard">Seat Dashboard</a> and choose an open seat.</li>' +
      '<li>Enter the email address of the person who will use it. ' +
        'Assign it to yourself and it is active straight away.</li>' +
      '<li>They receive an invitation by email and accept it by signing in with that same address. ' +
        'The invitation is valid for 7 days.</li>' +
    '</ol>');

  var CSS = [
    '.bd-ahelp{grid-column:1/-1;margin:14px 0 0;max-width:640px}',
    '.bd-ahelp__d{border:1px solid rgba(var(--color-foreground,11 18 32),.16);border-radius:10px;',
    'background:rgba(var(--color-foreground,11 18 32),.03)}',
    '.bd-ahelp__s{list-style:none;cursor:pointer;padding:11px 14px;display:flex;align-items:center;',
    'gap:9px;font-size:14px;font-weight:600;line-height:1.35;',
    'color:rgba(var(--color-foreground,11 18 32),.88)}',
    '.bd-ahelp__s::-webkit-details-marker{display:none}',
    '.bd-ahelp__s svg{flex:0 0 auto;width:17px;height:17px;color:rgb(var(--color-button,31 86 229))}',
    '.bd-ahelp__s span:last-child{margin-left:auto;white-space:nowrap;font-weight:500;font-size:13px;',
    'color:rgba(var(--color-foreground,11 18 32),.6)}',
    '.bd-ahelp__b{padding:0 14px 13px;font-size:14px;line-height:1.55;',
    'color:rgba(var(--color-foreground,11 18 32),.78)}',
    '.bd-ahelp__b ol{margin:0;padding-left:19px}',
    '.bd-ahelp__b li{margin:0 0 7px}',
    '.bd-ahelp__b a{color:rgb(var(--color-button,31 86 229));text-decoration:underline;',
    'text-underline-offset:2px}',
    '.bd-ahelp__d+.bd-ahelp__d{margin-top:8px}'
  ].join('');

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3"/>' +
    '<path d="M12 17h.01"/></svg>';
  var ICON_SEATS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>' +
    '<path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>';

  function q(s, r) { return (r || document).querySelector(s); }

  function stijl() {
    if (document.getElementById('bd-ahelp-css')) return;
    var s = document.createElement('style');
    s.id = 'bd-ahelp-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function uitklap(icoon, kop, stappen) {
    return '<details class="bd-ahelp__d">' +
      '<summary class="bd-ahelp__s">' + icoon +
        '<span>' + veilig(kop) + '</span>' +
        '<span data-bd-ahelp-label>' + veilig(TOON) + '</span>' +
      '</summary>' +
      '<div class="bd-ahelp__b">' + stappen + '</div></details>';
  }

  function html() {
    return uitklap(ICON, KOP, STAPPEN) + uitklap(ICON_SEATS, SEAT_KOP, SEAT_STAPPEN);
  }

  function teken() {
    var anker = q('.bd-online-v72__buttons');
    if (!anker || !anker.parentNode) return;
    var blok = q('.bd-ahelp');
    if (!blok) {
      blok = document.createElement('div');
      blok.className = 'bd-ahelp';
      anker.parentNode.insertBefore(blok, anker.nextSibling);
    }
    var h = html();
    // Alleen herschrijven als de tekst echt wijzigt, anders klapt de details
    // dicht zodra het thema iets in de sectie aanpast.
    if (blok.getAttribute('data-h') !== h) {
      var open = Array.prototype.map.call(blok.querySelectorAll('details'), function (d) { return d.open; });
      blok.innerHTML = h;
      blok.setAttribute('data-h', h);
      Array.prototype.forEach.call(blok.querySelectorAll('details'), function (d, i) {
        if (open[i]) d.open = true;
        label(d);
        d.addEventListener('toggle', function () { label(d); });
      });
    }
  }

  function label(d) {
    var el = q('[data-bd-ahelp-label]', d);
    if (el) el.textContent = d.open ? VERBERG : TOON;
  }

  function start() {
    if (!q('.bd-online-v72__buttons')) return;
    stijl();
    teken();
    try {
      var doel = q('.bd-online-v72') || q('.bd-online-v72__buttons').parentNode;
      if (doel) new MutationObserver(function () { teken(); })
        .observe(doel, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
